export default {
    data() {
      return {
        testData: null,
      }
    },
  
    testFunction() {
      console.log("This is a test function");
    },

    /*
      Update the Name and Descrption for an existing Table
      Stored Proc = pr_admin_updateLocationTableGrid
    */
    updateLocationRecord(app, row){
      app.$http.post(app.$store.state.appSettings.webServiceUrl + 'UpdateLocationRecord',
      {
        LocationId: row.LocationId,
        LocationName: row.TableName,
        LocationDesc: row.TableDesc,
      }
      ).then(function(data){         
          //var responseData = JSON.parse(data.body);        
      });
    },
    /*
      Mark a location record as deleted.  The record is not actually removed from the SQL table
      Stored Proc = pr_admin_deleteLocationTableGrid
    */
    deleteLocationRecord(app, row){
      app.$http.post(app.$store.state.appSettings.webServiceUrl + 'DeleteLocationRecord',
      {
        LocationId: row.LocationId,
      }
      ).then(function(data){         
          //var responseData = JSON.parse(data.body);        
      });
    },
    /*
      Format a string as a phone number
    */
    formatPhoneNumber(phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        var intlCode = (match[1] ? '+1 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
      }
      return null
    },
}